import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';
import { CheckinPassengerInputSubHeaderComponent } from './checkin-passenger-input-sub-header.component';

@NgModule({
  declarations: [CheckinPassengerInputSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [CheckinPassengerInputSubHeaderComponent],
})
export class CheckinPassengerInputSubHeaderModule {}
